// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"383":"72158e6b","490":"2bc9e3a8","542":"c44991c1","572":"6d818b47","595":"015bd950","640":"311e2119","717":"f711e91e","793":"5c772903"}[chunkId] + ".css";
};